import React, { Fragment, useState, useEffect, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import "./CannedMessages.css";
import "../AdminPages.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useHistory, useLocation } from "react-router";
import CustomPagination from "../../pagination/Pagination";

const CannedMessages = () => {
  const [pageData, setPageData] = useState();
  const [page, setPage] = useState(1);
  const [schoolName, setSchoolName] = useState({ name: "" });
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const fetchSeqRef = useRef(0);
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [pageDataLoading, setPageDataLoading] = useState(false);
  let history = useHistory();
  let location = useLocation();
  const [schoolId, setSchoolId] = useState(
    location?.pathname?.split("/").pop()
  );

  const getSchoolsList = (value) => {
    setShowSchoolNameContainer(true);
    setSchoolNameLoading(true);
    GetAdminService.getSchoolsList(value)
    .then((data) => {
      setSchoolNameList(data?.data?.school);
      setSchoolNameLoading(false);
    })
    .catch((_error) => {
      setSchoolNameLoading(false);
      setSchoolNameList();
    });
  };

  const getPageData = (id, pageNum = page) => {
    if (!id || id === "canned") return;
    const seq = ++fetchSeqRef.current;
    setPageDataLoading(true);
    let obj = {
      page: pageNum,
      school: id
    };
    GetAdminService.getCannedPage(obj)
    .then((data) => {
      if (seq !== fetchSeqRef.current) return;
      setPageData(data.data);
      setPageDataLoading(false);
    })
    .catch(() => {
      if (seq !== fetchSeqRef.current) return;
      setPageDataLoading(false);
    });
  };

  const createCannedMessage = () => {
    setPageDataLoading(true);
    let obj = {
      messages: {
        en: {
          subject: "",
          body: ""
        },
        es: {
          subject: "",
          body: ""
        }
      },
      school_id: schoolId
    };
    GetAdminService.createCannedMessage(obj)
    .then((data) => {
      history.push(
        `/admin/canned-mesage/${data?.data?.id}?new=1&school=${
        data?.data?.school_id
        }`
      );
    })
    .catch(() => {
      setPageDataLoading(false);
    });
  };

  useEffect(() => {
    if (schoolId && schoolId !== "canned") {
      getPageData(schoolId, page);
    }
  }, [page, schoolId]);

  const editMessage = (id) => {
    history.push(`/admin/canned-mesage/${id}?school=${schoolId}`);
  };

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName({ name: schoolNameRef.current.value });
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList();
      setPageData([]);
      setSchoolId("canned");
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedSchoolName = (item) => {
    setSchoolName(item);
    setShowSchoolNameContainer(false);
    setPage(1);
    setSchoolId(item?.id);
  };

  const handlePageChange = (nextPage) => {
    if (nextPage === page) return;
    setPage(nextPage);
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Canned Messages</h2>
              {pageData &&
              <button
                className="admin-students-new-btn"
                onClick={createCannedMessage}>
                
                  <FontAwesomeIcon icon={faEnvelope} />
                  New Canned
                </button>}
              
            </div>

            <div className="admin-students-school-selector">
              <label>Select School</label>
              <div className="school-input-wrapper">
                <input
                  ref={schoolNameRef}
                  type="text"
                  placeholder="Type to search school name..."
                  value={schoolName.name}
                  onChange={handleSchoolName}
                  autoComplete="off" />
                
                {showSchoolNameContainer &&
                <ul className="school-dropdown">
                    {schoolNameLoading && <CustomLoader />}
                    {schoolNameList?.length > 0 &&
                  schoolNameList.map((item, index) =>
                  <li
                    onClick={() => handleSelectedSchoolName(item)}
                    key={index}>
                    
                          {item.name}
                        </li>
                  )}
                  </ul>}
                
              </div>
            </div>

            {pageData &&
            <div className="admin-students-list-section">
                {pageDataLoading && <CustomLoader />}
                <div className="admin-student-list-container">
                  <p className="admin-students-heading">Canned Messages</p>
                  {pageData?.result
                ?.filter((item) =>
                Boolean(String(item?.messages?.en?.subject || "").trim())
                )
                .map((item, index) =>
                <div
                  key={item?.id || index}
                  className="message-list"
                  onClick={() => editMessage(item?.id)}>
                  
                      {item?.messages?.en?.subject}
                    </div>
                )}
                </div>
                {(pageData?.max > 1 || pageData?.page_list?.length > 1) &&
              <div className="admin-page-pagination">
                    <CustomPagination
                  count={pageData}
                  pageValue={page}
                  setPage={handlePageChange} />
                
                  </div>}
              
              </div>}
            
          </div>
        </div>
      </div>
    </Fragment>);

};

export default CannedMessages;